import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const links = [
  { to: "/", label: "Home" },
  { to: "/initiatives", label: "Initiatives" },
  { to: "/events", label: "Events" },
  { to: "/heritage", label: "Heritage" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 bg-parchment text-ocean transition-shadow ${
        scrolled ? "border-b border-ocean/10 shadow-[0_1px_0_rgba(11,31,77,0.04)]" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
        <Link to="/" data-testid="navbar-brand" className="flex items-center gap-3 group">
          <img
            src="https://youngindians.net/wp-content/uploads/2022/10/YI-PNG-logo-e1680601364574.png"
            alt="Young Indians logo"
            className="h-10 w-auto"
          />
          <div className="leading-tight hidden sm:block border-l border-ocean/20 pl-3">
            <div className="font-serif text-base tracking-tight">Kozhikode</div>
            <div className="font-serif text-base tracking-tight">Chapter</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `overline transition-colors hover:text-saffron ${
                  isActive ? "text-saffron" : "text-ocean/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="navbar-cta-join"
            className="overline px-4 py-2 border border-ocean text-ocean hover:bg-ocean hover:text-parchment transition-colors"
          >
            Join the chapter
          </Link>
        </nav>

        <button
          data-testid="navbar-mobile-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-ocean/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `overline ${isActive ? "text-saffron" : "text-ocean"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
